import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'mkui-fd';
export default function PreviewModal(props) {
  var prefixCls = props.prefixCls,
      visible = props.visible,
      previewUrl = props.previewUrl,
      onCancel = props.onCancel;
  return React.createElement("div", {
    className: prefixCls
  }, React.createElement(Modal, {
    visible: visible,
    className: "".concat(prefixCls, "-modal"),
    onCancel: onCancel,
    footer: null,
    getContainer: false
  }, React.createElement("div", null, React.createElement("img", {
    className: "".concat(prefixCls, "-img"),
    src: previewUrl,
    alt: "\u6682\u65E0\u9884\u89C8"
  }))));
}
PreviewModal.defaultProps = {
  prefixCls: 'mkui-enhanced-upload-preview-modal'
};
PreviewModal.propTypes = {
  prefixCls: PropTypes.string,
  onCancel: PropTypes.func,
  previewUrl: PropTypes.string,
  visible: PropTypes.bool
};
//# sourceMappingURL=PreviewModal.js.map
